export const languageCodes: any = Object.freeze({
    english: 'en',
    french: 'fr',
    spanish: 'es',
    simplifiedChinese: 'zh-hans'
});